import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/warning-red.svg'


const _hoisted_1 = { class: "w-full flex flex-col items-start" }
const _hoisted_2 = { class: "text-base leading-[26px] tracking-[0.01rem] font-medium text-[#898790] pb-[6px]" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "flex gap-1 items-center mt-1"
}
const _hoisted_5 = { class: "text-[#ed857f] text-sm" }



type Props = {
  title?: string;
  isRequired?: boolean;
  placeholder?: string;
  isError?: boolean;
  errorMessage?: string;
  modelValue: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionnaireTextField',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    isRequired: { type: Boolean },
    placeholder: {},
    isError: { type: Boolean },
    errorMessage: {},
    modelValue: {}
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const textModel = _useModel<string>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
    _withDirectives(_createElementVNode("input", {
      class: _normalizeClass(["p-3 mb-1 rounded-primary-radius border resize-none w-full outline-none bg-[#F9F8F6] text-black text-base leading-[26px] tracking-[0.01rem] font-medium placeholder:text-[#898790]", `${__props.isError ? 'border-[#ED857F]' : ''} 
          ${!__props.isError && !textModel.value ? 'border-[#E3E1EA]' : ''} 
          ${textModel.value && textModel.value.length > 0 ? 'border-[#393840]' : ''} `]),
      type: "text",
      placeholder: __props.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textModel).value = $event))
    }, null, 10, _hoisted_3), [
      [_vModelText, textModel.value]
    ]),
    (__props.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: _imports_0,
            alt: "Warning"
          }, null, -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.errorMessage), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})